import NotificationsDigestSettings from "../NotificationsDigestSettings"

function NotificationDigestSettingsAugmentation() {
  return <NotificationsDigestSettings />
}

export default NotificationDigestSettingsAugmentation
